import { Component } from '@angular/core';
import { Platform } from '@ionic/angular';

@Component({
  selector: 'itl-modal-page',
  templateUrl: 'modal-page.component.html',
  styleUrls: ['modal-page.component.scss'],
  standalone: false,
})
export class ModalPageComponent {}
